import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/zera/Navbar';
import Footer from '@/components/zera/Footer';
import { Clock, User, ArrowRight, Search } from 'lucide-react';

const blogPosts = [
  {
    id: 1,
    title: 'The Albanian Riviera: Europe\'s Last Unspoiled Coastline',
    excerpt: 'From the turquoise waters of Ksamil to the dramatic cliffs of Himarë, discover why the Albanian Riviera is being called the next big thing in Mediterranean travel.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776959882265_79251313.png',
    location: 'Ksamil',
    category: 'Destinations',
    author: 'Elena Hoxha',
    date: 'March 15, 2026',
    readTime: '8 min read',
    featured: true,
  },
  {
    id: 2,
    title: 'Berat: A Thousand Windows Into Albania\'s Soul',
    excerpt: 'Walking through the UNESCO-listed streets of Berat is like stepping back in time. Here\'s your complete guide to this Ottoman masterpiece.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776959912293_d78f42c5.png',
    location: 'Berat',
    category: 'Heritage',
    author: 'Marco Bellini',
    date: 'March 8, 2026',
    readTime: '6 min read',
    featured: false,
  },
  {
    id: 3,
    title: 'Theth to Valbona: The Greatest Trek in the Balkans',
    excerpt: 'The legendary crossing through the Accursed Mountains is one of Europe\'s most spectacular hikes. Here\'s everything you need to know.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776959930015_028937b3.jpg',
    location: 'Albanian Alps',
    category: 'Adventure',
    author: 'Arben Krasniqi',
    date: 'February 28, 2026',
    readTime: '10 min read',
    featured: false,
  },
  {
    id: 4,
    title: 'Albanian Cuisine: A Culinary Journey Through the Mediterranean',
    excerpt: 'From fresh seafood on the Riviera to mountain lamb in the Alps, Albanian food is a revelation. Discover the dishes you must try.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776959999702_28c4c309.png',
    location: 'Tirana',
    category: 'Culinary',
    author: 'Sofia Dervishi',
    date: 'February 20, 2026',
    readTime: '7 min read',
    featured: false,
  },
  {
    id: 5,
    title: 'Gjirokastër: The City of Stone That Time Forgot',
    excerpt: 'Perched on a hillside in southern Albania, Gjirokastër\'s stone architecture and massive fortress tell a story spanning centuries.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776960040332_7c4dcea8.png',
    location: 'Gjirokastër',
    category: 'Heritage',
    author: 'Elena Hoxha',
    date: 'February 12, 2026',
    readTime: '5 min read',
    featured: false,
  },
  {
    id: 6,
    title: 'Yacht Charter Guide: Sailing the Albanian Coast',
    excerpt: 'Everything you need to know about chartering a yacht along Albania\'s stunning coastline — from hidden coves to the best anchorages.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776960116238_6e928e60.png',
    location: 'Ionian Coast',
    category: 'Luxury',
    author: 'Marco Bellini',
    date: 'February 5, 2026',
    readTime: '9 min read',
    featured: false,
  },
  {
    id: 7,
    title: 'The Blue Eye: Albania\'s Most Mesmerizing Natural Wonder',
    excerpt: 'Deep in the forests of southern Albania lies a karst spring of impossibly blue water. Here\'s why it should be on your bucket list.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776960176282_ce780013.png',
    location: 'Blue Eye',
    category: 'Nature',
    author: 'Arben Krasniqi',
    date: 'January 28, 2026',
    readTime: '4 min read',
    featured: false,
  },
  {
    id: 8,
    title: 'Luxury Villas in Albania: The Ultimate Guide',
    excerpt: 'From beachfront estates to restored Ottoman mansions, Albania\'s luxury villa scene is booming. Here are our top picks.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776960195233_3410de94.jpg',
    location: 'Sarandë',
    category: 'Luxury',
    author: 'Sofia Dervishi',
    date: 'January 20, 2026',
    readTime: '6 min read',
    featured: false,
  },
  {
    id: 9,
    title: 'Things to Do in Tirana: Albania\'s Vibrant Capital Nightlife',
    excerpt: 'From the neon-lit rooftop bars of Blloku to hidden speakeasies in old bunkers, Tirana\'s nightlife rivals any Balkan capital. Your complete guide to the best bars, clubs, and late-night eats.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964453089_2ef3d1e0.png',
    location: 'Tirana',
    category: 'Destinations',
    author: 'Sofia Dervishi',
    date: 'March 12, 2026',
    readTime: '7 min read',
    featured: false,
  },
  {
    id: 10,
    title: 'Ksamil Islands Boat Tour: Albania\'s Caribbean-Like Paradise',
    excerpt: 'Discover the four tiny islets just off Ksamil beach — complete with crystal-clear water, secret coves, and the best snorkeling on the Albanian Riviera. Here\'s how to plan the perfect day trip.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964472469_b590b439.jpg',
    location: 'Ksamil',
    category: 'Adventure',
    author: 'Marco Bellini',
    date: 'March 5, 2026',
    readTime: '6 min read',
    featured: false,
  },
  {
    id: 11,
    title: 'Apollonia: Walking Through Albania\'s Ancient Greek Legacy',
    excerpt: 'The ruins of ancient Apollonia — once home to Augustus and Cicero — are among Europe\'s most underrated archaeological sites. A guide to Albania\'s Illyrian-Greek heritage.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964491157_56e154cd.jpg',
    location: 'Fier',
    category: 'Heritage',
    author: 'Elena Hoxha',
    date: 'February 26, 2026',
    readTime: '5 min read',
    featured: false,
  },
  {
    id: 12,
    title: 'Butrint National Park: Albania\'s UNESCO Archaeological Jewel',
    excerpt: 'Layers of Greek, Roman, Byzantine, and Venetian history stacked in a lush lagoon forest. Why Butrint is the single most rewarding heritage day trip in Albania.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964538508_29c48405.png',
    location: 'Butrint',
    category: 'Heritage',
    author: 'Elena Hoxha',
    date: 'February 22, 2026',
    readTime: '8 min read',
    featured: false,
  },
  {
    id: 13,
    title: 'Driving the Llogara Pass: Albania\'s Most Beautiful Road',
    excerpt: 'A thousand meters above the Ionian Sea, the Llogara Pass delivers one of Europe\'s most jaw-dropping scenic drives. Here\'s what to expect on this legendary coastal route.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964556894_8335208b.jpg',
    location: 'Llogara',
    category: 'Adventure',
    author: 'Arben Krasniqi',
    date: 'February 18, 2026',
    readTime: '6 min read',
    featured: false,
  },
  {
    id: 14,
    title: 'Shkodër: Gateway to Lake Skadar and the Albanian Alps',
    excerpt: 'With Rozafa Castle watching over the Balkans\' largest lake, Shkodër is a city of legends, cafés, and cycling culture. Everything you need to plan your stay.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964576117_3ce23b8c.jpg',
    location: 'Shkodër',
    category: 'Destinations',
    author: 'Sofia Dervishi',
    date: 'February 14, 2026',
    readTime: '7 min read',
    featured: false,
  },
  {
    id: 15,
    title: 'Durrës: Where the Roman Empire Meets the Adriatic',
    excerpt: 'Home to the largest Roman amphitheater in the Balkans and Albania\'s longest beach, Durrës blends ancient ruins with seaside resort culture in a way no other city can.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964620322_3462e3af.png',
    location: 'Durrës',
    category: 'Heritage',
    author: 'Marco Bellini',
    date: 'February 8, 2026',
    readTime: '6 min read',
    featured: false,
  },
  {
    id: 16,
    title: 'Komani Lake Ferry: The Most Scenic Boat Ride in Europe',
    excerpt: 'A 3-hour journey through fjord-like canyons in the Albanian Alps — the Komani Lake ferry is the unforgettable gateway to Valbona and Theth. Tickets, timings, and tips.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964696298_b052fd61.png',
    location: 'Komani Lake',
    category: 'Adventure',
    author: 'Arben Krasniqi',
    date: 'February 2, 2026',
    readTime: '7 min read',
    featured: false,
  },
  {
    id: 17,
    title: 'Dhërmi Beach Guide: Albania\'s Summer Party Capital',
    excerpt: 'White pebble beaches by day, beach clubs by night. Dhërmi has become the Riviera\'s premier summer destination — here\'s where to stay, swim, and dance until sunrise.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964731777_8b04900e.jpg',
    location: 'Dhërmi',
    category: 'Destinations',
    author: 'Sofia Dervishi',
    date: 'January 30, 2026',
    readTime: '6 min read',
    featured: false,
  },
  {
    id: 18,
    title: 'Himarë: The Soul of the Albanian Riviera',
    excerpt: 'Whitewashed villages, secret beaches, and centuries-old Greek Orthodox churches. Himarë is where the Riviera\'s old character still lives — and why you should visit soon.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964750606_8d8d392b.jpg',
    location: 'Himarë',
    category: 'Destinations',
    author: 'Elena Hoxha',
    date: 'January 24, 2026',
    readTime: '7 min read',
    featured: false,
  },
  {
    id: 19,
    title: 'The Complete Saranda Travel Guide: Gateway to the Riviera',
    excerpt: 'Just across from Corfu, Saranda is Albania\'s busiest seaside city and the perfect base for exploring Butrint, the Blue Eye, and Ksamil. Your complete 2026 guide.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964769379_8df1fed7.jpg',
    location: 'Sarandë',
    category: 'Destinations',
    author: 'Marco Bellini',
    date: 'January 17, 2026',
    readTime: '9 min read',
    featured: false,
  },
  {
    id: 20,
    title: 'Kruja Castle and Bazaar: Walking in Skanderbeg\'s Footsteps',
    excerpt: 'Perched on a mountain cliff above Tirana, Kruja is where Albania\'s national hero held off the Ottoman Empire. A day trip through medieval castles and traditional bazaars.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964788937_453c43d5.jpg',
    location: 'Krujë',
    category: 'Heritage',
    author: 'Elena Hoxha',
    date: 'January 12, 2026',
    readTime: '6 min read',
    featured: false,
  },
  {
    id: 21,
    title: 'Përmet: Albania\'s Emerald Wellness Escape',
    excerpt: 'Along the wild Vjosa River, Përmet offers natural thermal baths, slow food, and some of Albania\'s best raki. A wellness getaway deep in the south.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964807196_4f0525b6.jpg',
    location: 'Përmet',
    category: 'Nature',
    author: 'Sofia Dervishi',
    date: 'January 6, 2026',
    readTime: '5 min read',
    featured: false,
  },
  {
    id: 22,
    title: 'Benja Thermal Springs: Albania\'s Hidden Hot Pools',
    excerpt: 'Beneath an Ottoman arched bridge in a dramatic limestone canyon, the Benja thermal pools are the most atmospheric wild spa experience in the Balkans.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964946952_fe2cdce7.jpg',
    location: 'Benjë',
    category: 'Nature',
    author: 'Arben Krasniqi',
    date: 'December 30, 2025',
    readTime: '4 min read',
    featured: false,
  },
  {
    id: 23,
    title: 'Vlorë: Where the Adriatic Meets the Ionian Sea',
    excerpt: 'The birthplace of Albanian independence and the northern gateway to the Riviera. Vlorë combines history, beaches, and one of the country\'s best seafood scenes.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776964965090_6bf1506d.jpg',
    location: 'Vlorë',
    category: 'Destinations',
    author: 'Marco Bellini',
    date: 'December 22, 2025',
    readTime: '7 min read',
    featured: false,
  },
  {
    id: 24,
    title: 'Valbona Valley: Hiking the Heart of the Albanian Alps',
    excerpt: 'Snow-capped peaks, glacial rivers, and stone-roofed shepherds\' huts. Valbona National Park is the ultimate base for exploring Albania\'s legendary "Accursed Mountains".',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776965104705_15103bcb.jpg',
    location: 'Valbona',
    category: 'Adventure',
    author: 'Arben Krasniqi',
    date: 'December 15, 2025',
    readTime: '9 min read',
    featured: false,
  },
  {
    id: 25,
    title: 'Theth Waterfall and the Blue Eye of Theth',
    excerpt: 'Inside Theth National Park, the Grunas Waterfall and the glacial Blue Eye pool are two of the most magical hikes in Albania. Everything you need to visit both.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776965151404_8f88c47e.png',
    location: 'Theth',
    category: 'Nature',
    author: 'Arben Krasniqi',
    date: 'December 8, 2025',
    readTime: '6 min read',
    featured: false,
  },
  {
    id: 26,
    title: 'Albanian Wine Tour: The Balkans\' Best-Kept Secret',
    excerpt: 'From indigenous Shesh i Bardhë whites to bold Kallmet reds, Albanian wine is having a moment. Discover the country\'s best wineries and wine routes.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776965184891_f03585c6.jpg',
    location: 'Berat',
    category: 'Culinary',
    author: 'Sofia Dervishi',
    date: 'December 1, 2025',
    readTime: '6 min read',
    featured: false,
  },
  {
    id: 27,
    title: 'Raki 101: A Traveler\'s Guide to Albania\'s National Drink',
    excerpt: 'Grape, plum, mulberry, or mani — Albanian raki comes in endless forms and is a cornerstone of hospitality. How to drink it, where to buy it, and which to bring home.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776965207232_06303ad3.jpg',
    location: 'Tirana',
    category: 'Culinary',
    author: 'Marco Bellini',
    date: 'November 24, 2025',
    readTime: '4 min read',
    featured: false,
  },
  {
    id: 28,
    title: 'Best Time to Visit Albania: A Month-by-Month Guide',
    excerpt: 'From quiet spring hikes to peak summer beaches and golden autumn vineyards, here\'s exactly when to plan your Albania trip for perfect weather and fewer crowds.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776965223597_56a7a464.jpg',
    location: 'Albanian Riviera',
    category: 'Destinations',
    author: 'Elena Hoxha',
    date: 'November 16, 2025',
    readTime: '8 min read',
    featured: false,
  },
  {
    id: 29,
    title: 'Driving in Albania: A Road Trip Survival Guide',
    excerpt: 'Renting a car is the best way to explore Albania — but there are a few things you should know first. Road rules, fuel stops, parking, and our favorite self-drive routes.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776965389882_1f6dedff.jpg',
    location: 'Albanian Alps',
    category: 'Adventure',
    author: 'Arben Krasniqi',
    date: 'November 8, 2025',
    readTime: '7 min read',
    featured: false,
  },
  {
    id: 30,
    title: 'Albanian Language Essentials: 25 Phrases Every Traveler Needs',
    excerpt: 'Albanians light up when you try their language. From "faleminderit" to "gëzuar", here are the phrases that will unlock warmer welcomes everywhere you go.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776965289475_62b61e89.png',
    location: 'Tirana',
    category: 'Culinary',
    author: 'Sofia Dervishi',
    date: 'October 30, 2025',
    readTime: '5 min read',
    featured: false,
  },
  {
    id: 31,
    title: 'Corfu Day Trip from Saranda: Two Countries in One Day',
    excerpt: 'A 30-minute ferry from Saranda drops you in Corfu Old Town. Why this cross-border day trip is one of the smartest additions to any Albanian Riviera itinerary.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1776965308530_5b9388d7.jpg',
    location: 'Corfu',
    category: 'Adventure',
    author: 'Marco Bellini',
    date: 'October 22, 2025',
    readTime: '6 min read',
    featured: false,
  },
];



const categories = ['All', 'Destinations', 'Heritage', 'Adventure', 'Culinary', 'Luxury', 'Nature'];

const TravelBlog: React.FC = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPost, setSelectedPost] = useState<typeof blogPosts[0] | null>(null);

  const filteredPosts = blogPosts.filter((post) => {
    const matchesCategory = activeCategory === 'All' || post.category === activeCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchQuery.toLowerCase()) || post.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const featuredPost = blogPosts.find((p) => p.featured);
  const regularPosts = filteredPosts.filter((p) => !p.featured || activeCategory !== 'All');

  return (
    <div className="min-h-screen bg-[#FAF8F3]">
      <Navbar />

      {/* Hero — text only */}
      <section className="relative w-full overflow-hidden bg-[#1A3B5C] pt-24">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-8 pb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[1px] bg-[#C9A961]" />
            <span className="font-sans text-[10px] tracking-[0.4em] uppercase text-[#C9A961]">Journal</span>
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light text-white leading-[1.1] mb-4">
            Travel Stories
          </h1>
          <p className="font-sans text-sm text-white/70 max-w-xl leading-relaxed">
            Insights, guides, and inspiration from our journeys across Albania.
          </p>
        </div>
      </section>



      {/* Search & Filter */}
      <section className="py-12 border-b border-[#E8DFD0]">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="flex flex-wrap gap-3">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`font-sans text-[10px] tracking-[0.15em] uppercase px-5 py-2.5 border transition-all ${
                    activeCategory === cat
                      ? 'border-[#C9A961] bg-[#C9A961] text-white'
                      : 'border-[#E8DFD0] text-[#999] hover:border-[#C9A961]'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>
            <div className="relative w-full md:w-72">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#999]" />
              <input
                type="text"
                placeholder="Search articles..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2.5 border border-[#E8DFD0] font-sans text-sm text-[#1A3B5C] focus:outline-none focus:border-[#C9A961] bg-transparent"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Featured Post */}
      {activeCategory === 'All' && !searchQuery && featuredPost && (
        <section className="py-16">
          <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
            <button onClick={() => setSelectedPost(featuredPost)} className="w-full text-left group">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                <div className="relative aspect-[16/10] lg:aspect-auto overflow-hidden">
                  <img src={featuredPost.image} alt={featuredPost.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute top-4 left-4 bg-[#C9A961] px-4 py-2">
                    <span className="font-sans text-[9px] tracking-wider uppercase text-white">Featured</span>
                  </div>
                </div>
                <div className="bg-white p-10 lg:p-16 flex flex-col justify-center">
                  <span className="font-sans text-[10px] tracking-[0.2em] uppercase text-[#C9A961] mb-4">{featuredPost.category}</span>
                  <h2 className="font-serif text-2xl md:text-3xl text-[#1A3B5C] font-light mb-4 group-hover:text-[#C9A961] transition-colors">{featuredPost.title}</h2>
                  <p className="font-sans text-sm text-[#666] leading-relaxed mb-6">{featuredPost.excerpt}</p>
                  <div className="flex items-center gap-4 text-[#999]">
                    <div className="flex items-center gap-1.5">
                      <User className="w-3.5 h-3.5" />
                      <span className="font-sans text-xs">{featuredPost.author}</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <Clock className="w-3.5 h-3.5" />
                      <span className="font-sans text-xs">{featuredPost.readTime}</span>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </div>
        </section>
      )}

      {/* Blog Grid */}
      <section className="py-16">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          {filteredPosts.length === 0 ? (
            <div className="text-center py-20">
              <p className="font-serif text-2xl text-[#1A3B5C] mb-2">No articles found</p>
              <p className="font-sans text-sm text-[#999]">Try adjusting your search or category filter.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {(activeCategory === 'All' && !searchQuery ? regularPosts.filter(p => !p.featured) : filteredPosts).map((post) => (
                <button key={post.id} onClick={() => setSelectedPost(post)} className="text-left group bg-white border border-[#E8DFD0] hover:border-[#C9A961]/30 transition-all duration-500 overflow-hidden">
                  <div className="relative aspect-[3/2] overflow-hidden">
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm px-3 py-1">
                      <span className="font-sans text-[9px] tracking-wider uppercase text-[#C9A961]">{post.category}</span>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="font-serif text-lg text-[#1A3B5C] font-light mb-2 group-hover:text-[#C9A961] transition-colors line-clamp-2">{post.title}</h3>
                    <p className="font-sans text-xs text-[#666] leading-relaxed mb-4 line-clamp-3">{post.excerpt}</p>
                    <div className="flex items-center justify-between text-[#999]">
                      <span className="font-sans text-[10px]">{post.date}</span>
                      <span className="font-sans text-[10px]">{post.readTime}</span>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Article Modal */}
      {selectedPost && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 overflow-y-auto" onClick={() => setSelectedPost(null)}>
          <div className="bg-white max-w-3xl w-full my-8" onClick={(e) => e.stopPropagation()}>
            <div className="relative aspect-video">
              <img src={selectedPost.image} alt={selectedPost.title} className="w-full h-full object-cover" />
              <button onClick={() => setSelectedPost(null)} className="absolute top-4 right-4 w-10 h-10 bg-white/90 flex items-center justify-center hover:bg-white transition-colors">
                <span className="text-[#1A3B5C] text-xl">&times;</span>
              </button>
            </div>
            <div className="p-10">
              <div className="flex items-center gap-4 mb-4">
                <span className="font-sans text-[10px] tracking-[0.2em] uppercase text-[#C9A961]">{selectedPost.category}</span>
                <span className="font-sans text-[10px] text-[#999]">{selectedPost.date}</span>
              </div>
              <h2 className="font-serif text-3xl text-[#1A3B5C] font-light mb-4">{selectedPost.title}</h2>
              <div className="flex items-center gap-4 mb-8 text-[#999]">
                <div className="flex items-center gap-1.5">
                  <User className="w-3.5 h-3.5" />
                  <span className="font-sans text-xs">{selectedPost.author}</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <Clock className="w-3.5 h-3.5" />
                  <span className="font-sans text-xs">{selectedPost.readTime}</span>
                </div>
              </div>
              <div className="prose prose-sm max-w-none">
                <p className="font-sans text-sm text-[#666] leading-relaxed mb-4">
                  Albania continues to captivate travelers who venture beyond the well-worn paths of European tourism. With its stunning natural beauty, rich cultural heritage, and warm hospitality, this Balkan gem offers experiences that rival — and often surpass — its more famous Mediterranean neighbors.
                </p>
                <p className="font-sans text-sm text-[#666] leading-relaxed mb-4">
                  Whether you're drawn to the crystal-clear waters of the Riviera, the ancient stones of UNESCO heritage cities, or the dramatic peaks of the Albanian Alps, there's a story waiting to be discovered around every corner.
                </p>
                <p className="font-sans text-sm text-[#666] leading-relaxed">
                  At Zera Travel, we believe the best stories are the ones you live. Let us help you write yours in Albania.
                </p>
              </div>

              <div className="mt-8 pt-8 border-t border-[#E8DFD0]">
                <button onClick={() => { setSelectedPost(null); navigate('/booking'); }} className="font-sans text-[10px] tracking-[0.2em] uppercase text-[#C9A961] flex items-center gap-2 hover:gap-3 transition-all">
                  Plan Your Journey <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Accordion image strip — moved to bottom of page, static, non-interactive */}
      <section className="relative w-full overflow-hidden bg-[#1A3B5C]">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-16 pb-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[1px] bg-[#C9A961]" />
            <span className="font-sans text-[10px] tracking-[0.4em] uppercase text-[#C9A961]">Gallery</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-light text-white leading-[1.1] mb-3">
            Every Story Has a Place
          </h2>
          <p className="font-sans text-sm text-white/70 max-w-xl leading-relaxed">
            A visual index of every destination featured in our journal.
          </p>
        </div>

        <div
          aria-hidden="true"
          className="relative w-full overflow-hidden select-none pointer-events-none"
        >
          {/* Auto-scrolling carousel — duplicated list for seamless loop */}
          <div className="flex w-max gap-3 animate-[journal-scroll_90s_linear_infinite]">
            {[...blogPosts, ...blogPosts].map((post, idx) => (
              <div
                key={`${post.id}-${idx}`}
                className="relative shrink-0 w-[360px] md:w-[480px] aspect-[3/2] overflow-hidden"
              >
                <img
                  src={post.image}
                  alt=""
                  draggable={false}
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/50" />
              </div>
            ))}
          </div>

          <style>{`
            @keyframes journal-scroll {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
          `}</style>
        </div>
      </section>



      <Footer />
    </div>
  );
};

export default TravelBlog;
